var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-help", style: `paddingTop:${_vm.barHeight}px` },
    [
      _c("van-nav-bar", {
        staticClass: "van-bar",
        attrs: { title: "", "left-arrow": "" },
        on: { "click-left": _vm.closeWeb },
        scopedSlots: _vm._u([
          {
            key: "left",
            fn: function () {
              return [
                _c("img", {
                  staticClass: "left-nav",
                  attrs: {
                    src: require("@/assets/packageAssets/common/arrow05.png"),
                    alt: "",
                  },
                  on: { "click-left": _vm.closeWeb },
                }),
                _c("span", { staticClass: "tit-left" }, [
                  _vm._v(_vm._s(_vm.$t("lang.level.title"))),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("div", { staticClass: "main" }, [
        _c(
          "div",
          { staticClass: "table" },
          [
            _c("tr", [
              _c("th", { staticClass: "level th1" }, [
                _c("div", [
                  _vm._v(" " + _vm._s(_vm.$t("lang.inRule.th1")) + " "),
                ]),
              ]),
              _c("th", { staticClass: "rate" }, [
                _c("div", [
                  _vm._v(" " + _vm._s(_vm.$t("lang.level.th2")) + " "),
                ]),
              ]),
              _c("th", { staticClass: "rate" }, [
                _c("div", [
                  _vm._v(" " + _vm._s(_vm.$t("lang.level.th3")) + " "),
                ]),
              ]),
              _c("th", { staticClass: "rate th4" }, [
                _c("div", [
                  _vm._v(" " + _vm._s(_vm.$t("lang.level.th4")) + " "),
                  _c("span", [_vm._v("(beans/min)")]),
                ]),
              ]),
            ]),
            _vm.code == "BR"
              ? [
                  _vm._m(0),
                  _vm._m(1),
                  _vm._m(2),
                  _vm._m(3),
                  _vm._m(4),
                  _vm._m(5),
                  _vm._m(6),
                  _vm._m(7),
                ]
              : [
                  _vm._m(8),
                  _vm._m(9),
                  _vm._m(10),
                  _vm._m(11),
                  _vm._m(12),
                  _vm._m(13),
                  _vm._m(14),
                  _vm._m(15),
                ],
          ],
          2
        ),
        _c("div", { staticClass: "notes" }, [
          _c("div", { staticClass: "tit" }, [
            _vm._v(_vm._s(_vm.$t("lang.level.notes"))),
          ]),
          _c("div", [_vm._v(_vm._s(_vm.$t("lang.level.notes1")))]),
          _c("div", [_vm._v(_vm._s(_vm.$t("lang.level.notes2")))]),
          _c("div", [_vm._v(_vm._s(_vm.$t("lang.level.notes3")))]),
          _c("div", [_vm._v(_vm._s(_vm.$t("lang.level.notes4")))]),
          _c("div", [_vm._v(_vm._s(_vm.$t("lang.level.notes5")))]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticClass: "level" }, [_vm._v("L0")]),
      _c("td", { staticClass: "rate" }, [_vm._v("0min")]),
      _c("td", { staticClass: "rate" }, [_vm._v("50%")]),
      _c("td", { staticClass: "rate" }, [_vm._v("280")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticClass: "level" }, [_vm._v("L1")]),
      _c("td", { staticClass: "rate" }, [_vm._v("10mins")]),
      _c("td", { staticClass: "rate" }, [_vm._v("52%")]),
      _c("td", { staticClass: "rate" }, [_vm._v("290")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticClass: "level" }, [_vm._v("L2")]),
      _c("td", { staticClass: "rate" }, [_vm._v("30mins")]),
      _c("td", { staticClass: "rate" }, [_vm._v("54%")]),
      _c("td", { staticClass: "rate" }, [_vm._v("300")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticClass: "level" }, [_vm._v("L3")]),
      _c("td", { staticClass: "rate" }, [_vm._v("50mins")]),
      _c("td", { staticClass: "rate" }, [_vm._v("56%")]),
      _c("td", { staticClass: "rate" }, [_vm._v("310")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticClass: "level" }, [_vm._v("L4")]),
      _c("td", { staticClass: "rate" }, [_vm._v("70mins")]),
      _c("td", { staticClass: "rate" }, [_vm._v("58%")]),
      _c("td", { staticClass: "rate" }, [_vm._v("320")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticClass: "level" }, [_vm._v("L5")]),
      _c("td", { staticClass: "rate" }, [_vm._v("90mins")]),
      _c("td", { staticClass: "rate" }, [_vm._v("60%")]),
      _c("td", { staticClass: "rate" }, [_vm._v("330")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticClass: "level" }, [_vm._v("L6")]),
      _c("td", { staticClass: "rate" }, [_vm._v("120mins")]),
      _c("td", { staticClass: "rate" }, [_vm._v("62%")]),
      _c("td", { staticClass: "rate" }, [_vm._v("340")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticClass: "level" }, [_vm._v("L7")]),
      _c("td", { staticClass: "rate" }, [_vm._v("180mins")]),
      _c("td", { staticClass: "rate" }, [_vm._v("65%")]),
      _c("td", { staticClass: "rate" }, [_vm._v("350")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticClass: "level" }, [_vm._v("L0")]),
      _c("td", { staticClass: "rate" }, [_vm._v("0mins")]),
      _c("td", { staticClass: "rate" }, [_vm._v("50%")]),
      _c("td", { staticClass: "rate" }, [_vm._v("180")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticClass: "level" }, [_vm._v("L1")]),
      _c("td", { staticClass: "rate" }, [_vm._v("10mins")]),
      _c("td", { staticClass: "rate" }, [_vm._v("52%")]),
      _c("td", { staticClass: "rate" }, [_vm._v("190")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticClass: "level" }, [_vm._v("L2")]),
      _c("td", { staticClass: "rate" }, [_vm._v("30mins")]),
      _c("td", { staticClass: "rate" }, [_vm._v("54%")]),
      _c("td", { staticClass: "rate" }, [_vm._v("200")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticClass: "level" }, [_vm._v("L3")]),
      _c("td", { staticClass: "rate" }, [_vm._v("50mins")]),
      _c("td", { staticClass: "rate" }, [_vm._v("56%")]),
      _c("td", { staticClass: "rate" }, [_vm._v("210")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticClass: "level" }, [_vm._v("L4")]),
      _c("td", { staticClass: "rate" }, [_vm._v("70mins")]),
      _c("td", { staticClass: "rate" }, [_vm._v("58%")]),
      _c("td", { staticClass: "rate" }, [_vm._v("220")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticClass: "level" }, [_vm._v("L5")]),
      _c("td", { staticClass: "rate" }, [_vm._v("90mins")]),
      _c("td", { staticClass: "rate" }, [_vm._v("60%")]),
      _c("td", { staticClass: "rate" }, [_vm._v("230")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticClass: "level" }, [_vm._v("L6")]),
      _c("td", { staticClass: "rate" }, [_vm._v("120mins")]),
      _c("td", { staticClass: "rate" }, [_vm._v("62%")]),
      _c("td", { staticClass: "rate" }, [_vm._v("240")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticClass: "level" }, [_vm._v("L7")]),
      _c("td", { staticClass: "rate" }, [_vm._v("180mins")]),
      _c("td", { staticClass: "rate" }, [_vm._v("65%")]),
      _c("td", { staticClass: "rate" }, [_vm._v("250")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }